<template>
	<div class="full">
		<vxe-table :data="tableData" height="90%" border :tooltip-config="{showAll:true}">
			<vxe-column type="seq" width="60"></vxe-column>
			<vxe-column field="code" title="商品id"></vxe-column>
			<vxe-column show-overflow field="name" title="标题"></vxe-column>
			<vxe-column field="price" title="价格"></vxe-column>
			<vxe-column field="lowprice" title="最低价"></vxe-column>
			<vxe-column field="skuid" title="SKUID"></vxe-column>
			<vxe-column field="goodsname" title="sku名称"></vxe-column>
			<vxe-column field="goodscode" title="sku编码">
				<template #default="{ row }">
					<el-link type="primary" style="font-size: 12px;" @click="getgoodsidbygroupcode(row)">
						{{row.goodscode}}</el-link>
				</template>
			</vxe-column>
			<vxe-column field="goodsprice" title="价格"></vxe-column>
			<vxe-column field="nums" title="数量"></vxe-column>
			<vxe-column show-overflow field="link" title="商品链接">
				<template #default="{ row }">
					<el-link v-if="row.link" type="primary" style="font-size: 12px;" :href="row.link" target="_blank">跳转</el-link>
					<el-link v-else type="info" style="font-size: 12px;" disabled>跳转</el-link>
				</template>
			</vxe-column>

		</vxe-table>
	</div>
</template>
<style>

</style>
<style scoped>

</style>
<script>
	export default {
		name: 'onlineIndex',
		props: {
			row: {
				type: Object,
				default: () => {
					return {}
				}
			},
			list: {
				type: Object,
				default: () => {
					return null
				}
			},
		},
		data() {
			return {
				allAlign: null,
				tableData: []
			}
		},
		watch: {
			// row(e){
			// 	if(e){
			// 		this.getonline()
			// 	}		
			// }
		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			getonline() {
				this.$api.goods.getonlineinfo(this.row.id).then((res) => {
					this.tableData = res
				})
			},
			getgoodsidbygroupcode(row) {
				this.$api.goods.getgoodsidbygroupcode(row.goodscode).then((res) => {
					this.list.getGrid().commitProxy('query', {
						code: res.join(','),
						currentPage:-1,
						goodsurl:''
					})
				})
			}
		},
		components: {

		}
	}
</script>
